import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "./components/About";
import Navbar from "./components/Navbar";
import Movies from "./components/Movies";
import SearchBar from "./components/SearchBar";

import Sololev from "./Anime/Sololev";
import Jjk from "./Anime/Jjk";
import Mash from "./Anime/Mash";

function App() {
  return (
    <>
      <Navbar />
      <SearchBar />
      <Routes>
        <Route exact path="/" element={<Movies />} />
        <Route exact path="/home" element={<Movies />} />
        <Route exact path="/about" element={<About />} />
        {/* Anime Movies link start 😃🧐 */}

        <Route exact path="/sololev" element={<Sololev />} />
        <Route exact path="/jjk" element={<Jjk />} />
        <Route exact path="Mash" element={<Mash />} />
        {/* <Route exact path="" element={< />}     /> */}

        <Route
          path="/An Archdemons Dilemma: How to Love Your Elf Bride"
          element={<Mash id="1" />}
        />

        <Route path="/solo leveling" element={<Sololev id="2" />} />
      </Routes>
    </>
  );
}

export default App;
